import React, { createContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ns-dashboard-api.kabilah.com';

const CasesContext = createContext();

export const CasesProvider = ({ children }) => {
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCases = useCallback(() => {
    setLoading(true);
    axios.get(`${BACKEND_URL}/api/cases`)
      .then((res) => {
        if (Array.isArray(res.data)) setCases(res.data);
      })
      .catch(() => setCases([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchCases();
  }, [fetchCases]);

  return (
    <CasesContext.Provider value={{ cases, setCases, loading, fetchCases }}>
      {children}
    </CasesContext.Provider>
  );
};

export default CasesContext;
